import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { NotificationModel } from 'src/app/models/notification.model';
import { Survey } from 'src/app/models/survey.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-notification-detail',
  templateUrl: './notification-detail.component.html',
  styleUrls: ['./notification-detail.component.scss'],
})
export class NotificationDetailComponent implements OnInit, AfterViewInit {
  @Input() notificationData: NotificationModel;
  @ViewChild('descriptionElement') descriptionElement: ElementRef<HTMLElement>;

  rate = 0;
  processing = false;
  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    private authServ: AuthService,
    private modalServ: ModalMakerService,
    private requestServ: RequestService,
    private surveyServ: SurveyService,
    private router: Router,
  ) {}

  ngOnInit() {
    console.log(this.notificationData);
  }

  ngAfterViewInit(): void {
    this.descriptionElement.nativeElement.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', (e) => {
        const isBlank = a.getAttribute('target') === '_blank';

        if (isBlank) return;
        e.preventDefault();

        const href = a.getAttribute('href');

        if (
          href.includes(
            `${this.dataServ.rData.sub_domain_name}.guestservice.app`
          )
        ) {
          const path = href.split('.app').pop();

          this.router.navigateByUrl(path);

          this.dismissAll();
          
          return;
        }

        this.modalServ.openLink(a.getAttribute('href'));
      });
    });
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  dismissAll(modal?: HTMLIonModalElement) {
    (modal || this.mdlctrl).dismiss().then(async res => {
      const getNewTop = await this.mdlctrl.getTop();
      if (getNewTop) {
        Promise.resolve(this.dismissAll(getNewTop));
      } else {
        Promise.resolve(true);
      }
    });
  }

  async send() {
    this.processing = true;

    if (!this.authServ.isLogged) {
      this.modalServ.login();
      this.processing = false;
      return;
    }

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    const TITLE = this.notificationData.title;
    const DESC = this.notificationData.description;
    const TYPE = this.notificationData.type;

    const SURVEYDATA = new Survey(
      this.authServ.profile,
      TITLE,
      DESC,
      this.rate,
      TYPE
    );

    if (this.notificationData) {
      SURVEYDATA.item_id = this.notificationData.id;
    } else if (this.notificationData) {
      SURVEYDATA.survey_header_id = this.notificationData.id;
      SURVEYDATA.request_id = this.notificationData.request_id;

      try {
        const REQ = await this.requestServ.getRequestById(
          this.notificationData.request_id
        );

        if (REQ) {
          REQ.callback_survey_rating = this.rate;
          await this.requestServ.putRequest(REQ);
        }
      } catch {}
    }

    await this.surveyServ.postSurvey(SURVEYDATA);
    if (this.notificationData && this.notificationData.request_id) {
      await this.surveyServ.getSurveyByRequestId(
        this.notificationData.request_id
      );
    }

    this.close();
    this.processing = false;
  }
}
